import {authGuard} from '@common/auth/guards/auth-route';
import type {RouteObject} from 'react-router';

export const distributionRoutes: RouteObject[] = [
  {
    path: 'distribution-console',
    loader: () => authGuard({requireLogin: true}),
    lazy: () =>
      import('@app/distribution/distribution-console').then(({DistributionConsole}) => ({
        Component: DistributionConsole,
      })),
  },
];
